import { Component, Input } from '@angular/core';

@Component({
    selector: 'img-with-src-100px',
    template: `
        <img [hidden]="!value" class="app-image-fix-width-100px" [src]="value" [alt]="tooltip" [title]="tooltip"/>
    `,
    styles: [`
        .app-image-fix-width-100px {
            width: 100px;
            height: auto;
        }
    `]
})
export class ImgWithSrcComponentFixWidth100px {

    @Input()
    data: any = {};

    @Input()
    propertyName: string;

    @Input()
    tooltipPropertyName: string;

    public value: string | number;
    public tooltip: string;

    public ngOnInit() {
        this.value = this.data[this.propertyName];
        this.tooltip = this.data[this.tooltipPropertyName];
    }
}
